import { useState, useEffect } from 'react';
import { cn } from '@/lib/utils';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const navItems = [
    { name: 'HOME', href: '#home' },
    { name: 'ABOUT', href: '#about' },
    { name: 'PROJECTS', href: '#projects' },
    { name: 'SKILLS', href: '#skills' },
    { name: 'CONTACT', href: '#contact' },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id.substring(1));
    if (element) {
      const yOffset = -80; // Adjust offset to account for navbar height
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav 
      className={cn(
        "fixed top-0 left-0 w-full z-50 transition-all duration-300 py-4 px-6",
        isScrolled 
          ? "bg-white/90 backdrop-blur-sm shadow-md" 
          : "bg-[#e2eae0]/90 backdrop-blur-md"
      )}
    >
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <a 
          href="#home" 
          className="font-degular text-xl font-bold text-forest"
          onClick={(e) => {
            e.preventDefault();
            scrollToSection('#home');
          }}
        >
          PixelCraft
        </a>
        
        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-10">
          {navItems.map((item) => (
            <a 
              key={item.name}
              href={item.href}
              className="font-degular text-forest hover:text-grass transition-colors duration-300 text-sm tracking-wide"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(item.href);
              }}
            >
              {item.name}
            </a>
          ))}
        </div>
        
        {/* Mobile Menu Button */}
        <button 
          className="md:hidden flex flex-col space-y-1"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span className={cn(
            "w-6 h-0.5 bg-forest transition-all duration-300",
            isMobileMenuOpen && "transform rotate-45 translate-y-1.5"
          )}></span>
          <span className={cn(
            "w-6 h-0.5 bg-forest transition-all duration-300",
            isMobileMenuOpen && "opacity-0"
          )}></span>
          <span className={cn(
            "w-6 h-0.5 bg-forest transition-all duration-300",
            isMobileMenuOpen && "transform -rotate-45 -translate-y-1.5"
          )}></span>
        </button>
      </div>
      
      {/* Mobile Menu */}
      <div className={cn(
        "md:hidden absolute left-0 w-full bg-white/95 backdrop-blur-sm transition-all duration-300 overflow-hidden",
        isMobileMenuOpen ? "max-h-60 py-4 shadow-md" : "max-h-0 py-0"
      )}>
        <div className="flex flex-col space-y-4 px-6">
          {navItems.map((item) => (
            <a 
              key={item.name}
              href={item.href}
              className="font-degular text-forest hover:text-grass transition-colors duration-300 text-sm uppercase"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(item.href);
              }}
            >
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;